import React from 'react';
import { withTranslation } from 'react-i18next';
import { addReservationMerchandise } from "../../../models/reservation";
import { getMerchandise } from "./../../../models/setting";
import { Alert } from 'reactstrap';

import CurrencyFormat from '../../../components/snippets/currency-format';
import Button from '../../../components/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class KioskMerchandise extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      merch: null,
    }
    this.handleAddProducts = this.handleAddProducts.bind(this);
    this.setMerchandise = this.setMerchandise.bind(this);
    this.handleChangeMerchandise = this.handleChangeMerchandise.bind(this);
  }

  componentDidMount() {
    this.retrieveMerchandise();
  }

  retrieveMerchandise() {
    getMerchandise().then(
      (result) => {
        let merch = result;
        this.setState({
          merch,
          error: null
        }, () => {
          if(this.props.reservation){
            this.setMerchandise();
          }      
        });
      },
      (error) => {
        this.setState({ error });
      }
    );
  }

  setMerchandise() {
    if(this.props.reservation.merchandise&&this.props.reservation.merchandise.length){
      this.props.reservation.merchandise.forEach(m =>{
        this.setState({
          ['Product'+m.item]:m.quantity
        },() => {
          this.state.merch.forEach(m => {
            if(!this.props.reservation.merchandise.find(rm=>rm.item==m.item)){
              this.setState({['Product'+m.item]: 0})
            }
          })
        })
      })
    } else{
      this.state.merch.forEach(m => {
        this.setState({['Product'+m.item]: 0})
      })
    }
  }

  handleChangeMerchandise(e,item,clear){
    e.stopPropagation();
    // let value = e.target.value;
    // if(value.length>1&&value.startsWith("0")){
    //   value = value.substring(1);
    // }
    let currentValue = (this.state[item]||0);
    this.setState({[item]:clear?0:currentValue+1})
  }

  handleAddProducts(e) {
    e.preventDefault();
    let { reservation } = this.props;
    let merch = [];
    this.state.merch.forEach((m,i) =>{
      if(this.state[`Product${m.item}`] && parseInt(this.state[`Product${m.item}`]) > 0){
        merch.push({item: m.item,price:m.price, quantity:this.state[`Product${m.item}`], total:m.price*this.state[`Product${m.item}`]})
      }
    })
    let merchTotal = 0;
    if(merch.length){
      merch.forEach(m =>{
        merchTotal = merchTotal + (parseFloat(m.price) * parseFloat(m.quantity));
      })
    }
    addReservationMerchandise(reservation.reservationId,merch)
      .then(res => {
        this.props.handleUpdateReservation(res);
        this.props.handleScreenChange("pay");
        this.setState({error: null});
      }, error => {
        this.setState({
          error,
          isSubmitting: false,
        })
      });
  }

  render() {
    const { t, reservation, merchButton } = this.props;
    const { error, merch } = this.state;
    const totalQuantity = reservation.merchandise.reduce((sum, item) => sum + item.quantity, 0);
      return merch?
        merchButton?
          (merch.length?
            <div className="position-relative">
              <Button className="d-block mt-4 mb-4 mx-auto" size="lg" type="secondary" onClick={() => this.props.handleScreenChange('merchandise')}>{t('Add Merchandise')}</Button>
              {totalQuantity?
                <div className="excludedAmount">{totalQuantity}</div>
              :null}
            </div>
          :null)
        :
          <div className="col-12">
          <h2 className="mb-3">{t("Add Merchandise")}</h2>
          <form autoComplete="off" onSubmit={this.handleAddProducts} >
            {error?<Alert color="danger">{error}</Alert>:null}
            <div className="form-group">
              <div className="row">
                {merch && merch.map((item, i) => {
                  return <div className='col-4' key={i} onClick={(e) => this.handleChangeMerchandise(e,'Product'+item.item)}>
                    <div className="merch-product">
                      {this.state['Product'+item.item]?
                        <div className="merchAmount">{this.state['Product'+item.item]}</div>
                      :null}
                      <div className="mb-2">{item.item}</div>
                      <div><CurrencyFormat value={item.price} /></div>
                      {this.state['Product'+item.item]?
                        <div className="deleteMerchAmount" onClick={(e) => this.handleChangeMerchandise(e,'Product'+item.item, true)}><FontAwesomeIcon name="Remove Merch" className="" icon={['far', 'trash-alt']} /></div>
                      :null}
                    </div>
                  </div>
                })}
              </div>
            </div>
            <div>
              <Button className="btn-primary btn-lg mb-3" large>{t("Submit")}</Button>
            </div>
            <div>
              <Button type="outline-primary" onClick={() => this.props.handleScreenChange(reservation.advanceReservation?'confirm':'pay')}>{t('Cancel')}</Button>
            </div>
          </form>
        </div>
      :null
  }
}

export default withTranslation()(KioskMerchandise);